<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        库区基础信息
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            v-if="operationSuper.编辑"
            class="g-form-section-search operate__item"
            title="编辑"
            icon="el-icon-plus"
            @click="$router.push('/baseStorageAreaEdit')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.comparyName">
            <el-input
              v-model="slotForms.forms.comparyName"
              placeholder="企业名称"
              clearable
            ></el-input>
          </el-form-item>
          <!--<el-form-item prop="forms.countyNameId">-->
          <!--<dict-select-->
          <!--v-model="slotForms.forms.countyNameId"-->
          <!--placeholder="所属区(县)"-->
          <!--:pkey="'county_name'"-->
          <!--&gt;</dict-select>-->
          <!--</el-form-item>-->
          <el-form-item prop="forms.regisArea">
            <e6-city
              ref="e6City"
              :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
              class="e6-city"
              @selected="citySelect"
            ></e6-city>
          </el-form-item>
          <el-form-item>
            <e6Select
              :dataList="storageAreaTreeList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              multiple
              ref="storageAreaTreeSelect"
              :placeholder="'区位名称'"
              @multipleSelected="selectArea"
            ></e6Select>
          </el-form-item>
          <el-form-item prop="forms.storageMold">
            <dict-select
              v-model="slotForms.forms.storageMold"
              placeholder="仓库类型"
              :pkey="'storage_mold'"
              clearable
            ></dict-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @sort-change="sortable"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <template v-for="(item, index) in localShowTableCols">
          <el-table-column
            v-if="item.name !== 'volume'"
            :key="index"
            min-width="149"
            align="center"
            :show-overflow-tooltip="true"
            :prop="item.name"
            :label="item.title"
          >
          </el-table-column>
          <el-table-column
            v-else
            :key="index"
            min-width="149"
            align="center"
            :show-overflow-tooltip="true"
            :prop="item.name"
            :label="item.title"
            sortable="custom"
          >
          </el-table-column>
        </template>

        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <router-link
              v-if="operationSuper.编辑"
              :to="{
                path: '/baseStorageAreaEdit',
                query: { pageType: '2', id: scope.row.storageAreaId }
              }"
              >编辑</router-link
            >&nbsp;
            <el-button
              v-if="operationSuper.删除"
              @click="deleteRow(scope)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import e6City from "e6city";
import {
  FetchStorageAreaTree,
  DeleteStorageAreaInfoByIds
} from "@/api/base/storageArea.js";
import { mapActions } from "vuex";
import listInit from "@/mixins/listInit";
import { mergeFormExtend } from "_private/utils/merge";

import operationManage from "_private/mixins/operationManage";
export default {
  components: { e6City },
  mixins: [listInit, operationManage],
  data() {
    return {
      dataType: "object",
      isSearch: false,
      storageAreaTreeList: [],
      formExtend: {
        forms: {
          comparyName: "",
          countyNameId: "",
          provinceName: "",
          // provinceName: $GLOBAL_CONFIG.e6City.provinceName,
          cityName: "",
          // cityName: $GLOBAL_CONFIG.e6City.cityName,
          countyName: "",
          storageMold: ""
        },
        extends: []
      },
      formsExtend: [],
      idList: [],
      isFirstLoad: true,
      columSetVisible: false,
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      errMess: "",
      // 请求表格数据
      tableDataUrl: "/base/storageAreaInfo/findByPage",
      //导出URL
      exportUrl: "/base/storageAreaInfo/exportStorageAreaInfo?"
    };
  },

  created() {
    this.setSearchFormIsOpenAct();
    this.initPage();
  },
  mounted() {
    let comparyName = this.$route.query.comparyName;
    if (comparyName) {
      this.formExtend.forms.comparyName = comparyName;
    }
    let idStr = this.$route.query.storageAreaIds;
    if (idStr) {
      this.idList = idStr.split(",");
    }
    //初始化区位树
    this.initStorageAreaTree();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    handleExportClick() {
      let storageAreaIdList;
      if (this.isFirstLoad) {
        storageAreaIdList = this.idList;
        this.isFirstLoad = false;
      } else {
        storageAreaIdList = this.getStorageAreaIdListParam();
      }
      let param = "";
      param += "&comparyName=" + this.formExtend.forms.comparyName;
      param += "&storageAreaIdList=" + storageAreaIdList;
      param += "&countyNameId=" + this.formExtend.forms.countyNameId;
      param += "&provinceName=" + this.formExtend.forms.provinceName;
      param += "&cityName=" + this.formExtend.forms.cityName;
      param += "&countyName=" + this.formExtend.forms.countyName;
      document.location.href = this.exportUrl + param;
    },
    citySelect(res) {
      if (res.province.name == "澳门") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "香港") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "台湾省") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.city.name;
        this.formExtend.forms.countyName = res.district.name;
      }
    },
    // 删除行
    deleteRow({ row }) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.tableLoading = true;

          const { code, message } = await DeleteStorageAreaInfoByIds({
            ids: row.storageAreaId
          });

          this.tableLoading = false;

          if (code === 1) {
            this.successMessage("删除成功", () => {
              this.handleCurrentChange(1);
            });
          } else {
            this.errorMessage(message || "删除失败，请重试");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //初始化区位树
    initStorageAreaTree() {
      FetchStorageAreaTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.storageAreaTreeList = response.result;
            this.$nextTick(() => {
              this.$refs.storageAreaTreeSelect.setSelectList(this.idList);
              // this.isFirstLoad = true;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectArea() {
      // this.storageAreaTreeList = nodes.map(node=>node.id);
    },
    //获取选中区位id
    getStorageAreaIdListParam() {
      let selected = this.$refs.storageAreaTreeSelect.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    },
    // 整合查询数据
    mergeObj() {
      let storageAreaIdList;
      if (this.isFirstLoad) {
        storageAreaIdList = this.idList;
        this.isFirstLoad = false;
      } else {
        storageAreaIdList = this.getStorageAreaIdListParam();
      }
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        storageAreaIdList: storageAreaIdList,
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize,
          sortDir: "desc"
        }
      });
    },

    //排序
    sortable(row) {
      let params = this.mergeObj();
      //判断升序还是降序
      if (row.order === "ascending") {
        params.pageParamVO.sortDir = "ASC";
      } else if (row.order === "descending") {
        params.pageParamVO.sortDir = "DESC";
      }
      // params.pageParamVO.sortIndx = row.prop;
      //重新加载数据
      this.FetchFindByPage(params);
    },
    //重置
    handleResetForm() {
      this.$refs.storageAreaTreeSelect.multipleRemoveAll();
      this.$refs.e6City.clearCity();
      this.formExtend.forms.provinceName = "";
      this.formExtend.forms.cityName = "";
      this.formExtend.forms.countyName = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
